import "core-js/stable";
import startApp from "./Boot/StartApp";

startApp();
